import type { ChipStats } from './types';
import styles from './DailyDashboard.module.css';

const formatInt = (n: number) => n.toLocaleString();
const formatPct = (n: number) => `${(100 * n).toFixed(1)}%`;

export function SummaryChips({
  stats,
  model,
  day,
}: {
  stats: ChipStats;
  model: string;
  day: string;
}) {
  return (
    <div className={styles.chips}>
      <div className={`${styles.chip} ${styles.good}`}>
        <div className={styles.chipLbl}>Filled orders</div>
        <div className={styles.chipVal}>{formatInt(stats.filledOrders)}</div>
        <div className={styles.chipSub}>
          {day === 'all' ? 'across all days' : `on day ${day}`}
        </div>
      </div>
      <div className={`${styles.chip} ${styles.bad}`}>
        <div className={styles.chipLbl}>Unfilled orders</div>
        <div className={styles.chipVal}>{formatInt(stats.unfilledOrders)}</div>
        <div className={styles.chipSub}>can&apos;t ship within 5 days</div>
      </div>
      <div className={`${styles.chip} ${styles.warn}`}>
        <div className={styles.chipLbl}>Critical-PO orders</div>
        <div className={styles.chipVal}>{formatInt(stats.criticalOrders)}</div>
        <div className={styles.chipSub}>
          {stats.criticalFlowRows} flow rows depend on incoming POs
        </div>
      </div>
      <div className={styles.chip}>
        <div className={styles.chipLbl}>Fill rate</div>
        <div className={styles.chipVal}>{formatPct(stats.fillRate)}</div>
        <div className={styles.chipSub}>{model} overlay</div>
      </div>
    </div>
  );
}
